import { render, staticRenderFns } from "./GatGroup.vue?vue&type=template&id=5fcf2347&scoped=true&"
import script from "./GatGroup.vue?vue&type=script&lang=js&"
export * from "./GatGroup.vue?vue&type=script&lang=js&"
import style0 from "./GatGroup.vue?vue&type=style&index=0&id=5fcf2347&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf2347",
  null
  
)

export default component.exports